import { PrismCard, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

<template>
  <PrismCard class="myotb-card">
    <:content>
      <div
        class="myotb-card__content-container flex items-center justify-center"
      >
        <PrismMessage
          @description={{t "settings.my_otb.setup_in_progress.content"}}
          @illustration="100x100_critical"
          @title={{t "settings.my_otb.setup_in_progress.title"}}
          class="otb-empty-state flex justify-center"
        />
      </div>
    </:content>
  </PrismCard>
</template>
